export default __webpack_public_path__ + "static/media/bp-welcoming.e32f4cad.gif";